import DeleteQrCode from "./DeleteQrCode";

export default DeleteQrCode